var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFacebook = function SvgFacebook(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#159BA2",
    fillOpacity: 0.5,
    d: "M27.003.333h-24A2.666 2.666 0 0 0 .336 3v24a2.666 2.666 0 0 0 2.667 2.667h13.333v-12h-4v-4h4v-2.148c0-4.067 1.981-5.852 5.361-5.852 1.619 0 2.475.12 2.88.174v3.826h-2.305c-1.435 0-1.936.757-1.936 2.29v1.71h4.205l-.57 4h-3.635v12h6.667A2.666 2.666 0 0 0 29.669 27V3A2.667 2.667 0 0 0 27.003.333"
  })));
};
export default SvgFacebook;